import React from "react";
import styled from "styled-components";
import PageHeader from "../../components/organisms/PageHeader";
import Table from "../../components/molecules/Table"
import {device} from "../../assets/styles/media";
import SimbolTarget from "../../components/atoms/SimbolTarget";
import Bullet from "../../components/atoms/Bullet";

const Contents = styled.div`
    margin-bottom: 140px;
    ${device.mobile}{
        margin-top: 30px;
        margin-bottom: 50px;
    }
`;
const Section = styled.section`
    margin-bottom: 29px;
`;

const List = styled.ul`
    li:first-child {
        margin: 20px 0 0 12px;
    }

    ${device.tablet} {
        white-space: pre-wrap;
    }

  
`;

const Item = styled.li`
    padding-bottom: 8px;
    padding-left: 12px;
    color: #414141;
    margin: 8px 0 0 12px;
    ${device.mobile} {
        line-height: 20px;
    }
`;
const BorderText = styled.h5`
    font-size: 18px;
    display: inline-block;
    margin-top: 20px;
    padding: 7px 25px;
    border-radius: 20px;
    background-color: #e8e8e8;
    font-weight: 400;
    color: #000;
    ${device.tablet} {
        font-size: 17px;
        font-weight: bold;
    }
    
    ${device.mobile} {
        font-size: 13px;
        margin-top: 0;
        padding: 5px 20px;
        font-weight: bold;
    }
`;
const BulletList = styled.ul`
    margin-bottom: 20px;

    li:first-child {
        margin-top: 10px;
    }
    
`;
const BulletItem = styled.li`
    position: relative;
    margin: 12px 0 0 12px;
    font-size: 18px;
    color: #414141;
    white-space: pre-wrap;

    &:before {
        content: "";
        position: absolute;
        top: 8px;
        left: -12px;
        width: 4px;
        height: 4px;
        border-radius: 100%;
        background: #362579;
    }

    ${device.mobile} {
        letter-spacing: -0.6px;
        font-weight: 500;
        font-size: 13px;
        line-height: 20px;
    }

`;

const PricingGuide = () => {
    const infoList = [
        "입장권은 17:00까지 발권 가능합니다.", "강아지숲은 방문객들의 편의를 위해 테마파크 내 \n무료 셔틀버스 서비스를 제공하고 있습니다."
    ];
    const headers = [
        {
            name: "구분",
            width: "30%"
        },
        {
            name: "입장료",
            width: "30%"
        },
        {
            name: "비고",
            width: "40%"
        }
    ];
    const data = [
        ["성인", "17,000원", "만 19세 ~ 만 64세"],
        ["청소년", "15,000원", "만 13세 ~ 만 18세"],
        ["어린이", "12,000원", "37개월 ~ 만 12세"],
        ["반려견", "8,000원", "체중에 상관없이 \n 동일 요금 적용"],
    ];
    const headers2 = [
        {
            name: "구분",
            width: "35%"
        },
        {
            name: "금액",
            width: "30%"
        },
        {
            name: "비고",
            width: "35%"
        }
    ];

    const data2 = [
        ["유아 (36개월 이하)", "무료", "주민등록등본\n또는\n가족관계증명서\n지참 필수"],
        ["경로 (만 65세 이상)", "8,500원", "주민등록증\n또는 운전면허증\n지참 필수"],
        ["춘천 시민 (성인)", "8,500원", "주민등록증 또는\n운전면허증\n지참 필수"],
        ["춘천 시민 (청소년)", "7,500원", "학생증 지참 필수"],
        ["춘천 시민 (어린이)", "6,000원", "보호자 신분증\n지참 필수"],
        ["국가 유공자", "8,500원", "국가유공자증\n지참 필수"],
        ["1~3급 장애인", "8,500원", "장애인등록증\n또는\n장애인복지카드\n지참 필수"],
        ["장애인 보조견", "무료", "보조견 조끼 착용 \n및 정부 발급 표지 제시"],
        ["퍼피 워킹견", "무료", "보조견 조끼 착용 \n및 정부 발급 표지 제시"],
        ["단체 (20인 이상)", "20% 할인", "홈페이지 하단\n ‘단체예약’ 사전 신청"],
    ];
    const discountList = [
        "요금우대는 본인에 한하며, 해당 서류를 반드시 지참하셔야 적용 가능합니다.",
        "퍼피워킹 중인 강아지의 경우, 3개월 이상으로 예방접종(5차)이 완료되었을 시 입장 가능합니다.",
        "장애인 보조견 이외에 특수 목적견의 사회화 등을 위해 방문할 경우 사전 연락을 주시면 별도 응대해 드립니다.",
    ];
    const headers3 = [
        {name: "구분", width: "32%"},
        {name: "가입비", width: "26%"},
        {name: "혜택", width: "42%"}
    ];
    const data3 = [
        {
            title: "주중 1인 1두권",
            price: "120,000원",
            items: [
                {
                    desc1: "주중 한정 무료 입장 가능"
                },
                {
                    desc1: "주말, 공휴일 이용 시 20% 할인 적용",
                    desc2: "(멤버십 가입자에 한하여)"
                },
            ],
        },
        {
            title: "상시 1인 1두권",
            price: "150,000원",
            items: [
                {
                    desc1: "상시 무료 입장 가능",
                },
                {
                    desc1: "네이처풀 미드시즌 1회 한정 10% 할인",
                    desc2: "(중복할인 불가)",
                },
            ],
        },
        {
            title: "더블 상시\n2인 1두권",
            price: "200,000원",
            items: [
                {
                    desc1: "상시 무료 입장 가능",
                },
                {
                    desc1: "네이처풀 미드시즌 1회 한정 10% 할인",
                    desc2: "(중복할인 불가)",
                },
                {
                    desc1: "고급 산책 키트 제공",
                    desc2: "(1회 한정)",
                },
            ],
        },
        {
            title: "더블 상시\n2인 2두권",
            price: "240,000원",
            items: [
                {
                    desc1: "상시 무료 입장 가능",
                },
                {
                    desc1: "네이처풀 미드시즌 1회 한정 10% 할인",
                    desc2: "(중복할인 불가)",
                },
                {
                    desc1: "고급 산책 키트 제공",
                    desc2: "(1회 한정)",
                },
            ],
        },
    ];

    const sections = [
        {
            title: "공통 추가 혜택",
            items: [
                "동반인 2인 한정 20% 할인(주중&주말 모두 가능, 반려견 정상 요금 적용)",
                "카페 음료 상시 20% 할인(제조 음료에 한함, 중복 할인 불가)",
                "마켓 PB 상품 20% 할인(중복 할인 불가)",
                "네이처 푸드테라스 10% 할인(중복 할인 불가)",
            ],
        },
        {
            title: "가입 방법",
            items: [
                "현장 가입(현장 결제)\n(연간회원권 카드 제작은 가입비 결제 및 필요 서류 제출이 모두 확인된 날로부터 7일 가량이 소요되며, 발급 완료 시 문자로 수령 가능일을 안내 드립니다.)",
            ],
        },
        {
            title: "필요 서류",
            items: [
                "1. 연간회원권 가입 신청서",
                "2. 등록 본인 및 반려견 사진",
                "3. 반려동물 등록증 사본 또는 마이크로칩(내장 또는 외장)",
            ],
        },
        {
            title: "가입 조건",
            items: [
                "가입 시 반려동물 등록증 사본 또는 마이크로칩(내장, 외장) 중 택 1이 필수로 필요합니다.",
                "마이크로칩으로 인증하실 분들은 현장 방문 시 최초 1회 한하여 인증합니다.",
            ],
        },
        {
            title: "가입 안내",
            items: ["033-913-1400"],
        },
    ];

    // 화면 렌더링
    return (
        <>
            <PageHeader
                bTitle="이용안내"
                detail="요금안내"
                desc="강아지숲 요금을 안내해 드립니다."
            />

            <Contents>
                {/*입장요금*/}
                <Section>
                    <Table subTitle="입장요금" headers={headers} data={data}/>
                    <List>
                        {infoList.map((item) => (
                            <Item>
                                <Bullet>{item}</Bullet>
                            </Item>
                        ))}
                    </List>
                </Section>
                <SimbolTarget/>

                {/*우대정보*/}
                <Section>
                    <Table subTitle="우대 정보" headers={headers2} data={data2}/>
                    <List>
                        {discountList.map((item) => (
                            <Item>
                                <Bullet>{item}</Bullet>
                            </Item>
                        ))}
                    </List>
                </Section>
                <SimbolTarget/>


                {/*  연간회원권*/}
                <Section>
                    <Table subTitle="연간회원권" subText="혜택" headers={headers3} data={data3}/>
                </Section>
                {sections.map((section, index) => (
                    <div key={index}>
                        <BorderText>{section.title}</BorderText>
                        <BulletList>
                            {section.items.map((item, idx) => (
                                <BulletItem key={idx}>{item}</BulletItem>
                            ))}
                        </BulletList>
                    </div>
                ))}
            </Contents>
        </>
    );
};

export default PricingGuide;
